import { vendorCodeFromLink } from './vendorLinks';

export const IOS_STORE = 'https://apps.apple.com/us/app/scandeck-lead-capture/id6774784536';
export const ANDROID_STORE = 'https://play.google.com/store/apps/details?id=com.scandeck.app';
export interface RoutingFlags { ios: boolean; android: boolean }
export type VendorDevice = 'ios' | 'android' | 'desktop';
export interface GatewayContext {
	code: string | null;
	device: VendorDevice;
	legacy: boolean;
	nativeReady: boolean;
}
export function vendorDevice(userAgent: string, touchPoints = 0): VendorDevice {
	if (/iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && touchPoints > 1)) return 'ios';
	if (/Android/i.test(userAgent)) return 'android';
	return 'desktop';
}

/** No install sniffing: verified OS links open native apps before this page loads. */
export function gatewayContext(
	href: string, userAgent: string, touchPoints: number, native: boolean, flags: RoutingFlags,
): GatewayContext | null {
	if (native) return null;
	const url = new URL(href);
	const device = vendorDevice(userAgent, touchPoints);
	const nativeReady = device === 'ios' ? flags.ios : device === 'android' ? flags.android : false;
	const legacy = url.pathname === '/';
	const explicitGateway = ['/open', '/open/'].includes(url.pathname);
	// Legacy takeover is per-platform and disabled until its native release ships.
	// Explicit browser fallback, OTP login and demo host are never intercepted.
	if (!explicitGateway && !(legacy && nativeReady)) return null;
	if (url.hostname === 'demo.scandeckapp.com' || url.searchParams.has('web')
		|| url.searchParams.has('ec') || url.searchParams.has('em')) return null;
	const code = vendorCodeFromLink(`https://app.scandeckapp.com${url.pathname}${url.search}${url.hash}`);
	if (legacy && !code) return null;
	return { code, device, legacy, nativeReady };
}

export function vendorWebUrl(code: string): string {
	return `https://app.scandeckapp.com/?v=${encodeURIComponent(code)}&web=1`;
}
export function vendorNativeUrl(code: string): string {
	return `scandeck://vendor?v=${encodeURIComponent(code)}`;
}
export function automaticStore(context: GatewayContext): string | null {
	// Old printed root links land in a browser first. Require a deliberate app
	// open there rather than sending already-installed users straight to a store.
	if (!context.code || !context.nativeReady || context.legacy) return null;
	return context.device === 'ios' ? IOS_STORE : context.device === 'android' ? ANDROID_STORE : null;
}
